import { render, staticRenderFns } from "./LeadsUpload.vue?vue&type=template&id=e5edbb7e&scoped=true&"
import script from "./LeadsUpload.vue?vue&type=script&lang=ts&"
export * from "./LeadsUpload.vue?vue&type=script&lang=ts&"
import style0 from "./LeadsUpload.vue?vue&type=style&index=0&id=e5edbb7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5edbb7e",
  null
  
)

export default component.exports